
































































api = require('../../api.coffee').api
helpers = require('../../helpers.coffee')

view_model =
  data: ->
    apiErrorMessages: []
    email: ''
    showPassword: false
    showPasswordConfirmation: false
    user:
      invitation_token: ''
      name: ''
      password: ''
      password_confirmation: ''
      default_user: ''
      email: ''

  methods:
    hasInvitationToken: ->
      @$route.query && @$route.query.hasOwnProperty('invitation_token')

    redirectIfNoToken: ->
      if (@hasInvitationToken())
        @user.invitation_token = @$route.query.invitation_token
        @user.default_user = @$route.query.default_user == 'true'
      else
        @$router.push(path: '/login')

    extractEmailIfExists: ->
      @email = (@$route.query && @$route.query.email) || ''

    submit: ->
      @$validator.validateAll().then (success) =>
        @activateUser() if success

    activateUser: ->
      Loader.on()
      unless @user.default_user
        delete(@user.password)
        delete(@user.password_confirmation)
      @user.email = @email

      new UsersResource().activateInvitedUser @activationSuccess, @activationFailure, @user

    activationSuccess: (response) ->
      Loader.off()
      Session.signIn(response.body.user)
      @$router.push(name: 'flows')

    activationFailure: (response) ->
      Loader.off()
      @handleApiErrors(response, extra_attributes: ['email'])

  created: ->
    @redirectIfNoToken()
    @extractEmailIfExists()

  mounted: ->

exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/users/activation.vue